import { ReactNode } from 'react'

interface PageTitleProps {
	/** Kept for API compat — title is already shown in the page toolbar above. */
	title?: ReactNode
	/** Optional supporting description shown in the card header. */
	description?: ReactNode
	/** Primary action buttons shown on the LEFT of the card header. */
	actions?: ReactNode
	className?: string
}

/**
 * Card-header row. The page title is intentionally not rendered here
 * (it lives in PageBreadcrumbsWithLinks above the card to avoid duplication).
 * Only description and/or action buttons are rendered.
 * Returns null when neither is provided.
 */
const PageTitle: React.FC<PageTitleProps> = ({ description, actions, className = '' }) => {
	if (!description && !actions) return null

	return (
		<div className={`card-header ${className}`.trim()}>
			<div className="flex flex-wrap items-center gap-3">
				{actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
				{description && <p className="text-sm font-normal text-muted-foreground">{description}</p>}
			</div>
		</div>
	)
}

export default PageTitle
